import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import TagManager from "react-gtm-module";
import { fetchGetAuthHttp } from "../Utils/FetchApi";
import ApiNames from "../Constants/ApiNames";
import { encode as base64_encode } from "base-64";
import tagManagerEvents from "../Utils/GoogleTagManager";
import Awareness from "../Components/Awareness";
import { setCookie } from "../Utils/CommonFuntions";

const AwarenessScreen = (props) => {
  const search = useLocation().search;
  const utm_source = new URLSearchParams(search).get("utm_source");
  useEffect(() => {
    if (props.token) {
      // checkUtm();
      getAuthFlow();
    }
  }, [props.token]);
  useEffect(() => {
    gtmInitialization();
  }, []);

  const gtmInitialization = () => {
    const tagManagerArgs = {
      gtmId: "GTM-WSBVX5P",
    };
    TagManager.initialize(tagManagerArgs);
  };

  const getAuthFlow = async () => {
    try {
      tagManagerEvents("Request_Initiated", utm_source);
      let response = await fetchGetAuthHttp(
        ApiNames.awarenessFlow + "?utm_source=" + utm_source,
        props.token
      );
      if (response.status === 200) {
        if (response.response.result === 2 || response.response.result === 0) {
          tagManagerEvents("subscribe", "econTikTok");
          tagManagerEvents("Request_Success", utm_source);
          navigatetoHome(response.response.msisdn, response.response.sessionid);
        } else if (
          response.response.code === "1" &&
          response.response.desc.toLowerCase() === "already subscribe"
        ) {
          navigatetoHome(response.response.msisdn, response.response.sessionid);
        } else {
          tagManagerEvents("Request_Failed", utm_source);
          navigateToLanding();
        }
      } else {
        tagManagerEvents("Request_Failed", utm_source);
        navigateToLanding();
        console.log("Something went wrong.");
      }
    } catch (err) {
      tagManagerEvents("Request_Failed", utm_source);
      navigateToLanding();
      console.log("Error :" + err);
    }
  };

  const navigateToLanding = () => {
    let url = window.location.origin;
    url = `${url}/landing`;
    window.location.replace(url);
  };

  const navigatetoHome = (msisdn, token) => {
    setCookie(msisdn, token);
    let url = window.location.origin + "/home";
    if (url.includes("http:")) {
      url = url.replace("http", "https");
    }
    window.location.replace(url);
  };
  return <Awareness />;
};

export default AwarenessScreen;
